import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#0f1729] py-8 text-center" data-id="element-111">
        <p className="text-gray-500 text-sm" data-id="element-112">
          © 2025 El Escudo 1099. Todos los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-4 mt-3" data-id="element-113">
          <button onClick={() => setOpenModal('privacy')} className="text-gray-500 hover:text-[#c9a227] text-xs transition-colors duration-200 underline underline-offset-2" data-id="element-114">
            Política de Privacidad
          </button>
          <span className="text-gray-700 text-xs" data-id="element-115">•</span>
          <button onClick={() => setOpenModal('terms')} className="text-gray-500 hover:text-[#c9a227] text-xs transition-colors duration-200 underline underline-offset-2" data-id="element-116">
            Términos y Condiciones
          </button>
        </div>
        <p className="text-gray-600 text-xs mt-3 max-w-2xl mx-auto px-4" data-id="element-117">
          Descargo de responsabilidad: Esta guía es solo para fines educativos y
          no constituye asesoramiento fiscal profesional. Consulta con un
          profesional de impuestos certificado para tu situación específica.
        </p>
      </footer>

      <AnimatePresence data-id="element-118">
        {openModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setOpenModal(null)} data-id="element-119">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="bg-[#1a2744] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden border border-[#c9a227]/20" onClick={e => e.stopPropagation()} data-id="element-120">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-5 border-b border-white/10" data-id="element-121">
                <h2 className="text-lg font-bold text-white" data-id="element-122">
                  {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setOpenModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-gray-400 hover:text-white transition-colors" data-id="element-123">
                  <XIcon className="w-4 h-4" data-id="element-124" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto max-h-[calc(80vh-80px)] px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-125">
                {openModal === 'privacy' ? <>
                    <p className="text-gray-400 text-xs" data-id="element-126">
                      Última actualización: enero 2025
                    </p>
                    <p data-id="element-127">
                      En <strong className="text-white" data-id="element-128">El Escudo 1099</strong>,
                      respetamos tu privacidad y nos comprometemos a proteger la
                      información personal que compartes con nosotros al
                      realizar tu compra.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-129">
                      Información que recopilamos
                    </h3>
                    <p data-id="element-130">
                      Al realizar una compra, el procesador de pagos recopila la
                      información necesaria para completar la transacción
                      (nombre, correo electrónico, información de pago).
                      Nosotros únicamente recibimos tu correo electrónico para
                      enviarte el producto digital.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-131">
                      Uso de la información
                    </h3>
                    <p data-id="element-132">Tu correo electrónico se utiliza exclusivamente para:</p>
                    <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-133">
                      <li data-id="element-134">Enviarte el enlace de descarga de tu producto</li>
                      <li data-id="element-135">Comunicaciones relacionadas con tu compra</li>
                      <li data-id="element-136">
                        Actualizaciones importantes del producto (si aplica)
                      </li>
                    </ul>
                    <h3 className="text-white font-semibold mt-4" data-id="element-137">
                      Compartir información
                    </h3>
                    <p data-id="element-138">
                      No vendemos, alquilamos ni compartimos tu información
                      personal con terceros, excepto con los procesadores de
                      pago necesarios para completar tu transacción.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-139">Seguridad</h3>
                    <p data-id="element-140">
                      Todas las transacciones se procesan a través de
                      plataformas seguras con cifrado SSL. No almacenamos
                      información de tarjetas de crédito.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-141">Cookies</h3>
                    <p data-id="element-142">
                      Este sitio puede utilizar cookies básicas para mejorar tu
                      experiencia de navegación. No utilizamos cookies de
                      rastreo de terceros para publicidad.
                    </p>
                  </> : <>
                    <p className="text-gray-400 text-xs" data-id="element-143">
                      Última actualización: enero 2025
                    </p>
                    <p data-id="element-144">
                      Al adquirir{' '}
                      <strong className="text-white" data-id="element-145">El Escudo 1099</strong>,
                      aceptas los siguientes términos y condiciones. Por favor,
                      léelos detenidamente antes de realizar tu compra.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-146">
                      Producto digital
                    </h3>
                    <p data-id="element-147">
                      El Escudo 1099 es un producto digital descargable (eBook
                      en formato PDF). Una vez completada la compra, recibirás
                      acceso inmediato a tu descarga. Por la naturaleza digital
                      del producto,{' '}
                      <strong className="text-white" data-id="element-148">
                        no se aceptan devoluciones
                      </strong>{' '}
                      una vez que el archivo ha sido descargado o accedido.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-149">
                      Licencia de uso
                    </h3>
                    <p data-id="element-150">
                      Al comprar este producto, obtienes una licencia personal e
                      intransferible para uso individual. Está prohibido:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-151">
                      <li data-id="element-152">Reproducir, distribuir o revender el contenido</li>
                      <li data-id="element-153">Compartir el archivo con terceros</li>
                      <li data-id="element-154">Publicar el contenido en plataformas públicas</li>
                      <li data-id="element-155">
                        Utilizar el material con fines comerciales sin
                        autorización
                      </li>
                    </ul>
                    <h3 className="text-white font-semibold mt-4" data-id="element-156">
                      Descargo de responsabilidad
                    </h3>
                    <p data-id="element-157">
                      El contenido de esta guía es únicamente para fines
                      educativos e informativos. No constituye asesoramiento
                      fiscal, legal o financiero profesional. Los resultados
                      pueden variar según la situación individual de cada
                      persona. Se recomienda consultar con un profesional de
                      impuestos certificado (CPA) para tu situación específica.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-158">
                      Propiedad intelectual
                    </h3>
                    <p data-id="element-159">
                      Todo el contenido de El Escudo 1099, incluyendo textos,
                      diseños y materiales, está protegido por derechos de
                      autor. Queda prohibida su reproducción total o parcial sin
                      autorización expresa.
                    </p>
                    <h3 className="text-white font-semibold mt-4" data-id="element-160">
                      Modificaciones
                    </h3>
                    <p data-id="element-161">
                      Nos reservamos el derecho de actualizar estos términos en
                      cualquier momento. Las compras realizadas se rigen por los
                      términos vigentes al momento de la transacción.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}